// extracted by mini-css-extract-plugin
export default {"dialogRoot":"PasswordChangeDialog_dialogRoot__5Q498"};